import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalGuard, MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { isRunningInIframe, protectedResources } from '../msal-config';

// Uses redirect MSAL authentication for PPR (or popup fallback). When Redirect and then popup fallback fails for PPR in an iframe (browsers block popup), then attempts silent SSO.  Finally, falls back to redirecting to login page where user needs to manually click Login button.
export const CustomMsalGuard: CanActivateFn = async (route, state) => {
  if (!isRunningInIframe()) {
    return firstValueFrom(inject(MsalGuard).canActivate(route, state));
  }

  const msalService = inject(MsalService);
  const router = inject(Router);

  if (msalService.instance.getAllAccounts().length > 0) {
    return true;
  }

  try {
    await firstValueFrom(msalService.ssoSilent({ scopes: [...protectedResources.api.scopes.read] }));
    return true;
  } catch {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }
};
